import React from 'react'
import { Row } from 'react-foundation'

require('../style/css/third_party/foundation.css')
require('../style/css/third_party/animate.css')

require('../style/scss/custom/main.scss')

require('../style/css/custom/components/digitalArt.css')
require('../style/css/custom/main.css')

require('../js_animations/customAnimations.js')
require('../js_animations/scrollMagic.js')


const DigitalArt = () => (

<div className="digital-art" id="digital-art">



  <Row className="wow animated slideInLeft banner" data-wow-offset="200">
    <img src="https://s3-us-west-1.amazonaws.com/soniclouds-portfolio-assets/Digital_Art/banner_tpc_promo_2.jpg" alt="banner_tpc_promo_2" />
  </Row>

  <Row className="gallery-images">

    <img className="wow animated slideInRight" src="https://s3-us-west-1.amazonaws.com/soniclouds-portfolio-assets/Digital_Art/cover_1.jpg" alt="cover_1" data-wow-offset="300"/>

    <img className="wow animated slideInRight" src="https://s3-us-west-1.amazonaws.com/soniclouds-portfolio-assets/Digital_Art/cover_2.jpg" alt="cover_2" data-wow-offset="200"/>

    <img className="wow animated slideInRight" src="https://s3-us-west-1.amazonaws.com/soniclouds-portfolio-assets/Digital_Art/cover_3.jpg" alt="cover_3" data-wow-offset="100"/>


  </Row>



  <Row className="wow animated slideInLeft banner" data-wow-offset="200">
    <img src="https://s3-us-west-1.amazonaws.com/soniclouds-portfolio-assets/Digital_Art/banner_stage.jpg" alt="banner_stage" />
  </Row>


  <Row className="gallery-images">

    <img className="wow animated slideInRight" src="https://s3-us-west-1.amazonaws.com/soniclouds-portfolio-assets/Digital_Art/cover_4.jpg" alt="cover_4" data-wow-offset="300"/>

    {
      // <img src="https://s3-us-west-1.amazonaws.com/soniclouds-portfolio-assets/Digital_Art/cover_5.jpg" alt="cover_5" />
    }

    <img className="wow animated slideInRight" src="https://s3-us-west-1.amazonaws.com/soniclouds-portfolio-assets/Digital_Art/cover_back_3.jpg" alt="cover_back_3" data-wow-offset="200"/>

    <img className="wow animated slideInRight" src="https://s3-us-west-1.amazonaws.com/soniclouds-portfolio-assets/Digital_Art/cover_back_1.jpg" alt="cover_back_1" data-wow-offset="100"/>




  </Row>



  <Row className="wow animated slideInLeft banner" data-wow-offset="200">
    <img src="https://s3-us-west-1.amazonaws.com/soniclouds-portfolio-assets/Digital_Art/banner_chamber.jpg" alt="banner_chamber" />
  </Row>



</div>

// closes 'digital-art'


)

export default DigitalArt



// WEBPACK FOOTER //
// ./src/components/digitalArt.js